import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialogComponent } from 'src/app/pages/common/confirm-dialog/confirm-dialog.component';
import { SessionService } from 'src/app/service/session.service';
import { HttpClientService } from 'src/app/service/http-client.service';
import { LoaderService } from 'src/app/service/loader.service';
import { Utils } from 'src/app/const/func-util';
import { CommonConstants } from 'src/app/const/const';
import { FaqGetRequest, FaqGetResponse, FaqPostRequest } from 'src/app/interfaces/faq';
declare var $;

@Component({
  selector: 'app-com-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.scss']
})
export class FaqComponent implements OnInit {

  Const = CommonConstants;

  hoyo_sample_mst_list = this.sessionSvc.get('hoyo_sample_mst_list');
  login_company = Utils.getLoginCompany();
  companyCombo = { values: [], clearable: false, showOnFocus: false, disableSearch: true };
  company_list = Utils.getCompanyList();
  company_id = null;

  item_list = null;

  item_edit: FaqGetResponse = new FaqGetResponse();
  edit_type = 1;

  message = null;

  page_per_count = 5;
  pagination = {
    pages: new Array(),
    current: 0
  };

  processing = false;

  constructor(
    private httpClientService: HttpClientService,
    private sessionSvc: SessionService,
    private loaderSvc: LoaderService,
    private dialog: MatDialog,
  ) {
    this.loaderSvc.call();
  }

  ngOnInit(): void {
    this.initControl();
    this.getData(this.company_id);
  }

  initControl() {
    if (this.company_list) {
      this.companyCombo.values = this.company_list.map(value => ({ name: value.base_name, value: value.id, data: value }));
      if (this.login_company) {
        if (this.login_company.base_type === CommonConstants.BASE_TYPE_COMPANY) {
          this.company_id = this.login_company.id;
        } else {
          this.company_id = this.company_list[0].id;
        }
      }
    }
  }

  getData(company_id) {
    const request = new FaqGetRequest();
    request.company = company_id;
    if (!this.loaderSvc.isLoading) {
      this.loaderSvc.call();
    }
    this.httpClientService.getFaqList(request).then((response) => {
      Utils.log(response);
      this.item_list = response;
      this.calcPagination();
      this.loaderSvc.dismiss();

    }).catch(error => {
      this.loaderSvc.dismiss();
    });
  }
  calcPagination() {
    this.pagination.pages = new Array();
    this.pagination.current = 0;
    if (!this.item_list || !this.item_list.length) {
      return;
    }
    const count = Math.ceil(this.item_list.length / this.page_per_count);
    for (let i = 1; i <= count; i++) {
      this.pagination.pages.push(i);
    }
    this.pagination.current = 1;
  }

  companyChange(event) {
    if (!event || !event.data) {
      return;
    }
    this.getData(event.data.id);
  }

  showData(event, item = null) {
    this.message = null;
    if (!item) {
      this.edit_type = 1;
      this.item_edit = new FaqGetResponse();
      this.item_edit.company = this.company_id;
    } else {
      this.edit_type = 2;
      if (event.target.classList.contains('operation') || event.target.classList.contains('icon')) {
        return;
      }
      this.item_edit = JSON.parse(JSON.stringify(item));
    }
    $('#item-edit').modal({
      centered: false,
      closable: false,
      detachable: false,
      transition: 'fade'
    }).modal('show');
  }

  saveData() {
    this.sessionSvc.clear('message');
    if (this.processing) {
      return;
    }
    this.processing = true;
    if (!this.dataValidate()) {
      this.processing = false;
      return;
    }
    const postData = this.getPostData();
    this.loaderSvc.call();
    if (postData.id) {
      this.httpClientService.updateFaq(postData.id, postData)
        .then(async (response) => {
          Utils.log(response);
          this.sessionSvc.save('message', { type: 'info', title: 'FAQを保存しました。' });
          this.getData(this.company_id);
          this.loaderSvc.dismiss();
          this.processing = false;
        })
        .catch(error => {
          this.sessionSvc.save('message', { type: 'error', title: 'FAQの保存が失敗しました。' });
          this.loaderSvc.dismiss();
          this.processing = false;
        });
    } else {
      this.httpClientService.addFaq(postData)
        .then(async (response) => {
          Utils.log(response);
          this.sessionSvc.save('message', { type: 'info', title: 'FAQを保存しました。' });
          this.getData(this.company_id);
          this.loaderSvc.dismiss();
          this.processing = false;
        })
        .catch(error => {
          this.sessionSvc.save('message', { type: 'error', title: 'FAQの保存が失敗しました。' });
          this.loaderSvc.dismiss();
          this.processing = false;
        });
    }
    $('#item-edit').modal('hide');

  }
  dataValidate() {
    const msgs = new Array();
    this.message = null;
    if (!this.item_edit.display_num) {
      msgs.push('表示順');
    }
    this.item_edit.question = this.item_edit.question ? this.item_edit.question.trim() : this.item_edit.question;
    if (!this.item_edit.question) {
      msgs.push('質問');
    }
    this.item_edit.answer = this.item_edit.answer ? this.item_edit.answer.trim() : this.item_edit.answer;
    if (!this.item_edit.answer) {
      msgs.push('回答');
    }

    if (msgs.length > 0) {
      this.message = {
        type: 'warning',
        title: '必須項目が入力されておりません。',
        msg: msgs.join(',')
      };
      return false;
    }

    return true;
  }

  getPostData(): FaqPostRequest {
    const postRequest = new FaqPostRequest();
    postRequest.id = this.item_edit.id;
    postRequest.company = this.item_edit.company;
    postRequest.display_num = this.item_edit.display_num;
    postRequest.question = this.item_edit.question;
    postRequest.answer = this.item_edit.answer;
    return postRequest;
  }

  closeMessage() {
    this.message = null;
  }

  deleteData(id) {
    this.sessionSvc.clear('message');
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      data: {
        msg1: 'FAQを削除します、よろしいですか？',
      },
      width: '100%',
      maxWidth: '450px',
      maxHeight: '90%'
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === true) {
        this.loaderSvc.call();
        this.httpClientService.deleteFaq(id)
          .then((response) => {
            Utils.log(response);
            this.sessionSvc.save('message', { type: 'info', title: 'FAQを削除しました。' });
            this.getData(this.company_id);
          })
          .catch(error => {
            this.sessionSvc.save('message', { type: 'error', title: 'FAQの削除が失敗しました。' });
            this.loaderSvc.dismiss();
          });
      }
    });
  }

}
